import classnames from 'classnames'

import { formatNumber } from '../../../../util'
import { ETFHoldingsStandardResponse, ETFHoldingsStandardRowData } from '../types'
import { getSector } from '../utils'
import { TableNameColumn } from './TableNameColumn'

interface TableRowProps {
  rowData: ETFHoldingsStandardRowData
  isLimitedView: boolean
}

export function TableRow({ rowData, isLimitedView }: TableRowProps) {
  const sector = getSector(rowData.instrument, rowData.sector)
  return (
    <tr className="border-t border-primary text-default">
      <TableNameColumn rowData={rowData} />
      <td className="px-1.5 py-0 text-right font-medium">{formatNumber(rowData.weight * 100, { suffix: ' %' })}</td>
      <td title={sector} className="overflow-hidden text-ellipsis whitespace-nowrap px-1.5 py-0 text-left text-muted-2">
        {sector}
      </td>
      {!isLimitedView && (
        <td
          title={rowData.industry}
          className="overflow-hidden text-ellipsis whitespace-nowrap px-1.5 py-0 text-left text-muted-2"
        >
          {rowData.industry}
        </td>
      )}
    </tr>
  )
}

interface TableProps {
  data: ETFHoldingsStandardResponse
  limitDataTo?: number
  type: string
}

export function TableChart({ data, limitDataTo, type }: TableProps) {
  const dataToUse = limitDataTo ? data.rowData.slice(0, limitDataTo) : data.rowData
  const isLimitedView = limitDataTo !== undefined

  const dataTotal = dataToUse.reduce((prev, curr) => prev + curr.weight, 0) * 100
  return (
    <div className="w-full px-1.5" data-testid={`etf-holdings-${type}`}>
      <table className="w-full table-fixed text-2xs">
        <thead>
          <tr className="text-muted">
            <th
              className={classnames('px-1.5 text-left font-normal', {
                'w-3/5': isLimitedView,
                'w-1/3': !isLimitedView,
              })}
            >
              Name
            </th>
            <th className={classnames('px-1.5 text-right font-normal', { 'w-1/6': !isLimitedView })}>% Holdings</th>
            <th className={classnames('px-1.5 text-left font-normal', { 'w-1/4': isLimitedView })}>Sector</th>
            {!isLimitedView && <th className="px-1.5 text-left font-normal">Industry</th>}
          </tr>
        </thead>
        <tbody>
          {dataToUse.map((item, index) => (
            <TableRow key={index} rowData={item} isLimitedView={isLimitedView} />
          ))}
          {isLimitedView && (
            <tr className="border-t border-primary text-default">
              <td className="px-1.5 text-left">Percent of Portfolio in Top {limitDataTo} Holdings</td>
              <td className="px-1.5 text-right font-medium">{formatNumber(dataTotal, { suffix: ' %' })}</td>
              <td className="px-1.5 text-left"></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
